const {Backbone} = require('backboneAdapter');
import i18n from 'l10n';
import NavBarView from 'js/views/navbar.view';
import CampaignConfiguration from 'js/models/campaign.config.model';
import UserModel from 'js/models/userrelatedinfo.model';
import ServicesView from 'js/views/services.view';
import ChartView from 'js/views/reports-message-chart-simpleview';
import moment from 'moment';
import dashboardLineChartSimpleView from 'js/views/dashboard-line-chart-simpleview';
import dashboardContactsInfoView from 'js/views/dashboard-contacts-info.view';
import dashboardServicesInfoView from 'js/views/dashboard-services-info.view';
import dhtmlx from 'dhtmlxAdapter';

export default Backbone.Router.extend({
    routes: {
        "": "defaultRoute",
        "msg/:type": 'messageRoute'
    },
    messageRoute: function (type) {
        if (type === "alreadyRegistered") {
            dhtmlx.alert(i18n.t("login.msg-" + type));
        }
    },
    initialize: function () {
        this.navbar = new NavBarView();
        const self = this;
        $('.icon-cancel-2').attr('title', i18n.t("dashboard.neverShowAgain"));
        self.showPrompts();
        const $data = $('[data-i18n]');
        $data.i18n();
        $data.each(function () {
            if (typeof $(this).data("hint") === "string") {
                $.Metro.initAll(this);
            }
        });
        $('#send-sms-text').text(i18n.t("dashboard.smscampaigns"));
        $('#send-email-text').text(i18n.t("dashboard.emailcampaigns"));
        $('#redeemVoucher').text(i18n.t("voucher.redeem") + " " + i18n.t("voucher.voucher"));
        $('#survey-text').text(i18n.t("survey.new") + " " + i18n.t("survey.survey"));
        this.removeAllEvents(this.servicesView);
        this.servicesView = new ServicesView();
        $("#sendSms").click(function (ev) {
            self.sendSms(ev);
        });
        $("#sendEmail").click(function (ev) {
            self.sendEmail(ev);
        });
        $('#createNewInstantWin').click(function (ev) {
            self.servicesView.createNewLottery(ev);
        });
        $('#createNewSweepstake').click(function (ev) {
            self.servicesView.createNewLottery(ev);
        });
        $('.create-new-voucher').click(function (ev) {
            self.servicesView.createNewVoucher(ev);
        });
        $('.create-new-survey').click(function (ev) {
            self.servicesView.createNewSurvey(ev);
        });
        $('#redeem').click(function (ev) {
            self.servicesView.gotoRedeem(ev);
        });
        $('.cancelButton').click(function (ev) {
            self.promptClosedByUser(ev);
        });
    },
    defaultRoute : function () {
        const from = moment().startOf('day').subtract(6, 'days');
        const to = moment().endOf('day');
        const options = {
            from,
            to,
            window: null,
            queryOptions: {
                from: from.clone().toDate().getTime(),
                to: to.clone().toDate().getTime(),
                unit: "day",
                dow: null
            }
        };

        // This disables all the API calls that fetch statistics for the dashboard
        // dashboardContactsInfoView.init('#contact-tile', '#contact-tile-last-week');
        // dashboardServicesInfoView.init('#Dl-Url-OptOut-Voucher-data', '#services-tile-last-week');
        // (new ChartView()).init('.container', options);
        // dashboardLineChartSimpleView.init();
    },
    removeAllEvents: function (view) {
        if (view) {
            view.$el.off();
            view.$el.empty();
            view.undelegateEvents();
        }
    },
    sendSms: function (ev) {
        this.sendMessage(ev, 'SMS');
    },
    sendEmail: function (ev) {
        this.sendMessage(ev, 'EMAIL');
    },
    sendMessage: function (ev, channel) {
        const CCmodel = new CampaignConfiguration({campaignChannel: channel});
        const userModel = new UserModel();
        userModel.fetch({
            success: function () {
                CCmodel.set("userId", userModel.id);
                CCmodel.set("sender", ((channel === 'SMS') ?
                    userModel.get("username").replace(/\./g, "").substring(0, 11) :
                    userModel.get("username")));
                CCmodel.save(CCmodel.attributes, {
                    success : function (model) {
                        location.href = "Message.htm#" + model.get("id");
                    }
                });
            }
        });
        return false;
    },
    showPrompts: function () {
        $.ajaxDefaultQ({
            url : '/CampaignCloud/ShowPrompts/dashboard',
            type : 'get',
            dataType : 'json'
        }).done(function (response) {
            if (response) {
                if (response[0] === true) {
                    $('#dashboardImportContacts').html(i18n.t("dashboard.importContacts") + " " + '<i class="icon-tellody-group padding5"></i>');
                    const $dashboardGetMoreContacts = $('#dashboardGetMoreContacts');
                    $dashboardGetMoreContacts.html(i18n.t("dashboard.getMoreContacts") + " " + '<i class="icon-lamp-2 padding5"></i>');
                    $dashboardGetMoreContacts.attr('title', i18n.t("dashboard.getMoreContactsTitle"));
                    $('#noContactsPrompt').show();
                }
                if (response[1] === true) {
                    $('#goToProfile').html(i18n.t("dashboard.goToProfile") + " " + '<i class="icon-tellody-avatar padding5"></i>');
                    $('#moreProfileInfo').show();
                }
                if (response[2] === true) {
                    $('#goToServices').html(i18n.t("dashboard.goToServices") + " " + '<i class="icon-lamp-2 padding5"></i>');
                    $('#contactEngagement').show();
                }
            }
        }).fail(function (response) {
            console.log(response);
        });
    },
    promptClosedByUser: function (event) {
        const data = $(event.currentTarget).parent().parent().data();
        const id = data['id'];
        if (id !== undefined &&  id > 0 && id < 6) {
            $.ajaxDefaultQ({
                url : '/CampaignCloud/ShowPrompts/' + id,
                type : 'post',
                dataType : 'json'
            }).done(function (response) {
                if (response) {
                    if (response.toClose === true) {
                        $('[data-id=' + response.id + ']').hide();
                    }
                }
            }).fail(function (response) {
                console.log(response);
            });
        }
    }
});